import React, { useState, useEffect } from "react";
import CipHeader from "../Components/CipHeader";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useForm } from "react-hook-form";
import managementService from "../services/management-service";
import cogoToast from "cogo-toast";
import Loader from "react-loader-spinner";
import moment from "moment";
const FileUpload = ({ history }) => {
  const { register, errors, reset, getValues } = useForm({});
  const [loading, setLoading] = useState(false);
  const [totalMonths, setTotalMonths] = useState([]);
  const selectFile = (event) => {};
  const eomFileSelect = async (event) => {
    let report_month = getValues("report_month");
    let report_year = getValues("report_year");
    if (report_month === "" || report_year === "") {
      event.target.value = null;
      reset();
      const { hide } = cogoToast.error("Please select Month and Year.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    } else {
      let fileExtension = event?.target?.files[0]?.name?.split(".").pop();
      if (fileExtension === "xlsx") {
        setLoading(true);
        let formData = new FormData();
        formData.append("month", report_month);
        formData.append("year", report_year);
        formData.append("excel", event.target.files[0]);

        formData.append("uploadFileType", "eomFile");
        try {
          const response = await managementService.uploadEOMFile(formData);
          if (response) {
            reset();
            const { hide } = cogoToast.success(
              "EOM File Uploaded Successfully!!",
              {
                hideAfter: 15,
                onClick: () => {
                  hide();
                },
              }
            );
          }
        } catch (e) {
          const { hide } = cogoToast.error(
            "Error uploading EOM File. Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
        setLoading(false);
      } else {
        event.target.value = null;
        const { hide } = cogoToast.error("Please upload only excel file", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
    }
  };
  const facMasterFileUpload = async (event) => {
    let formData1 = new FormData();
    formData1.append("excel", event.target.files[0]);
    formData1.append("uploadFileType", "facMasterFile");
    try {
      const response = await managementService.uploadFMMaster(formData1);
      if (response) {
        reset();
        const { hide } = cogoToast.success("EOM File Uploaded Successfully!!", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error uploading EOM File. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const totalYears = () => {
    const years = [];
    const dateStart = moment().subtract(2, "y");
    const dateEnd = moment().add(6, "y");
    while (dateEnd.diff(dateStart, "years") >= 0) {
      years.push(dateStart.format("YYYY"));
      dateStart.add(1, "year");
    }
    return years;
  };
  const totalYearsList = () => {
    return totalYears().map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  };
  useEffect(() => {
    setTotalMonths(moment.months());
  }, []);
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">MANAGEMENT REPORTS FILE UPLOAD</span>
          </div>
        </div>
        <div className="px-12 pt-8">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload Facility Master
              </label>
              <input
                id="facilityMasterFile"
                name="facilityMasterFile"
                type="file"
                onChange={facMasterFileUpload}
                ref={register({
                  required: "You must select file",
                })}
                className={` ${
                  errors.facilityMasterFile ? "border-red-400" : ""
                } focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-1/2`}
              />
              {errors.facilityMasterFile && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.facilityMasterFile?.message}
                </p>
              )}
            </li>
          </ul>
        </div>
        <div className="pt-2 pr-12 pb-4 pl-12 border-b-2">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Report Month
              </label>
              <select
                name="report_month"
                aria-label="Select Report Month"
                ref={register({
                  required: "You must select Report Month",
                })}
                className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
              >
                <option value="">Select Report Month</option>
                {totalMonths
                  ? totalMonths.map((monthName, i) => {
                      return (
                        <option key={i} value={("0" + (i + 1)).slice(-2)}>
                          {monthName}
                        </option>
                      );
                    })
                  : null}
              </select>
              {errors.report_month && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  {errors.report_month?.message}
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Report Year
              </label>
              <select
                name="report_year"
                aria-label="Select Report Month"
                defaultValue="2021"
                ref={register({
                  required: false,
                })}
                className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
              >
                {totalYearsList()}
              </select>
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload End Of Month
              </label>
              <input
                id="eomFile"
                name="eomFile"
                type="file"
                onChange={eomFileSelect}
                ref={register({
                  required: "You must select file",
                })}
                className={` ${
                  errors.fileName ? "border-red-400" : ""
                } focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-1/2`}
              />
              {errors.eomFile && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.eomFile?.message}
                </p>
              )}
            </li>
          </ul>
        </div>
        <div className="pt-2 pr-12 pb-4 pl-12">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Report Month
              </label>
              <select
                name="inmed_report_month"
                aria-label="Select Report Month"
                ref={register({
                  required: "You must select Report Month",
                })}
                className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
              >
                <option value="">Select Report Month</option>
                {totalMonths
                  ? totalMonths.map((monthName, i) => {
                      return (
                        <option key={i} value={("0" + (i + 1)).slice(-2)}>
                          {monthName}
                        </option>
                      );
                    })
                  : null}
              </select>
              {errors.inmed_report_month && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  {errors.inmed_report_month?.message}
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Report Year
              </label>
              <select
                name="inmed_report_year"
                aria-label="Select Report Month"
                defaultValue="2021"
                ref={register({
                  required: false,
                })}
                className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
              >
                {totalYearsList()}
              </select>
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload InMed Invoice
              </label>
              <input
                id="inmedFile"
                name="inmedFile"
                type="file"
                disabled={true}
                onChange={selectFile}
                ref={register({
                  required: "You must select file",
                })}
                className={` ${
                  errors.inmedFile ? "border-red-400" : ""
                } focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-1/2`}
              />
              {errors.inmedFile && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.inmedFile?.message}
                </p>
              )}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(FileUpload)
);
